module.exports = __webpack_public_path__ + "img/video7.30da92d0.jpg";